import { render, staticRenderFns } from "./tutorCard.vue?vue&type=template&id=4e65aefc&"
import script from "./tutorCard.vue?vue&type=script&lang=js&"
export * from "./tutorCard.vue?vue&type=script&lang=js&"
import style0 from "./tutorCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports